<template>
  <div v-loading="loading">
    <div class="m-b-20 ovf-hd">
      <div class="fl">
        <router-link class="btn-link-large add-btn" to="addAbs">
          <i class="el-icon-plus"></i>&nbsp;&nbsp;添加功能集
        </router-link>
      </div>
			<div class="fl w-300 m-l-30" @keyup.enter="search()">
				<el-input v-model="keywords" placeholder="功能集搜索"></el-input>
			</div>
			<div class="fl m-l-20">
				<el-button type="primary" @click="search()">搜索</el-button>
			</div>
    </div>
    <el-table :data="tableData" style="width: 100%" @selection-change="selectItem">
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column label="名称" prop="name"></el-table-column>
      <el-table-column label="创建人" prop="create_name" width="200"></el-table-column>
      <el-table-column label="最近操作人" prop="update_name" width="200"></el-table-column>
      <el-table-column label="功能层级" width="150">
        <template scope="scope">
          {{ scope.row.level | level }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="create_time" width="200">
        <template scope="scope">
          <div>
            {{ scope.row.create_time | toDate }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="最后更新时间" prop="update_time" width="200">
        <template scope="scope">
          <div>
            {{ scope.row.update_time | toDate }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template scope="scope">
          <div>
            <span v-if="scope.row.level == 10">
              <el-button type="text" @click="openDialog(scope.row)">配置</el-button>
            </span>
            <span class="c-gra" v-else>配置</span>&nbsp;|&nbsp;
            <router-link :to="{ name: 'abstractEdit', params: { id: scope.row.id }}" class="btn-link edit-btn m-r-5">编辑</router-link>
            <el-button size="small" @click="deleteContent(scope.row.id)">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pos-rel p-t-20">
      <div class="block pages">
        <el-pagination
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
          :page-size="limit"
          :current-page="currentPage"
          :total="dataCount">
        </el-pagination>
      </div>
    </div>
    <configuration ref="configuration" :configData="configData"></configuration>
  </div>
</template>

<script>
  import configuration from './configuration.vue'
  import http from '../../../assets/js/http'

  export default {
    name: 'classify-list',
    data() {
      return {
        dataCount: null,
        currentPage: null,
        keywords: '',
        status: 1,
        multipleSelection: [],
        limit: 15,
        tableData: [],
        loading: false,
        configData: []
      }
    },
    filters: {
      level(value) {
        let level = ''
        switch (value) {
          case 10:
            level = '一级层级'
            break
          case 20:
            level = '二级层级'
            break
        }
        return level
      }
    },
    methods: {
      deleteContent(id) {
        this.$confirm('确认删除该实例?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.apiDelete('cms/contents/', id).then((res) => {
            if (res.code == 200) {
              _g.toastMsg(this, 'success', '删除成功')
              _g.updateMenus()
              setTimeout(() => {
                _g.reloadPage(this)
              }, 1500)
            } else {
              _g.dealError(this, res)
            }
          })
        }).catch(() => {
        })
      },
      search() {
        this.reloadPage()
      },
      selectItem(val) {
        this.multipleSelection = val
      },
      handleCurrentChange(page) {
        this.reloadPage(page)
      },
      reloadPage(page) {
        const query = {
          limit: this.limit,
          page: page || 1,
          keywords: this.keywords
        }
        router.push({ name: 'classifyList', query: query })
      },
      async getAllClassify() {
        let obj = {}
        let query = {
          params: {
            limit: this.limit,
            page: this.currentPage,
            keywords: this.keywords
          }
        }
        let res = await this.apiGet('cms/contents', query)
        return this.promiseHandler(obj, res)
      },
      getCurrentPage() {
        let data = this.$route.query
        let page = 1
        if (data && data.page) {
          page = parseInt(data.page)
        }
        return page
      },
      getKeywords() {
        let keywords = ''
        let data = this.$route.query
        if (data && data.keywords) {
          keywords = data.keywords
        }
        return keywords
      },
      getContentOperation(id) {
        let query = {
          params: {
            content_id: id
          }
        }
        return this.apiGet('cms/deals', query)
      },
      async checkOperationData(id) {
        let res = await this.getContentOperation(id)
        // let hasList = false
        let arr = []
        if (res.code == 200) {
          // _(res.data).forEach((ret) => {
          //   if (ret.type == 10) {   // 如果是列表
          //     if (!hasList) {
          //       hasList = true
          //       ret.name = '列表'
          //       arr.push(ret)
          //     }
          //   } else {
          //     arr.push(ret)
          //   }
          // })
          arr = res.data
        } else {
          arr = []
        }
        return arr
      },
      async init() {
        this.loading = true
        this.currentPage = this.getCurrentPage()
        this.keywords = this.getKeywords()
        let res = await this.getAllClassify()
        this.dataCount = res.dataCount || 0
        this.tableData = res.list || []
        this.loading = false
      },
      async openDialog(item) {
        this.loading = true
        let res = await this.checkOperationData(item.id)
        this.loading = false
        this.configData = res
        this.$refs.configuration.dialogShow = true
      }
    },
    created() {
      this.init()
    },
    watch: {
      '$route'(to, from) {               // 监听路由改变
        this.init()
      }
    },
    components: {
      configuration
    },
    mixins: [http]
  }

</script>


// WEBPACK FOOTER //
// list.vue?00ac2ea2